import React from 'react';
import {QRCode} from "antd";
import logo from "../../../images/logo2.svg";

const PrintPage = ({data, numberPerPallet}) => {
    return (<div className='p-1 text-black text-sm'>


            <div className='border  ' dir='rtl'>
                <div className="grid text-center text-sm font-bold grid-cols-2">
                    <div className=" border p-2   ">
                        <h1>شرکت بهنوش ایران</h1>

                    </div>

                    <div className="border p-2   ">
                        <h1>{data?.productLine}</h1>

                    </div>


                </div>
                <div className="border p-1 py-2">
                    <h2 className='text-center text-lg font-bold'>{data?.product}</h2>
                </div>
                <div className="grid grid-cols-3">

                    <div className="border p-2">
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">ق م:</div>
                            <div className="value !text-black">{data?.consumerPriceRials}</div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">ق ت:</div>
                            <div className="value !text-black">{data?.manufacturerPriceRials}</div>
                        </div>

                    </div>
                    <div className="border p-2">
                        <div className="flex items-center gap-2   justify-center  ">
                            <div className="key !text-sm !text-gray-800 whitespace-nowrap">تعداد در پالت:</div>
                            <div className="value !text-black">
                                {numberPerPallet}
                            </div>
                        </div>
                    </div>
                    <div className="border p-2">
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">شماره بچ:</div>
                            <div className="value !text-black">{data?.batchNumber}</div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">شماره پالت:</div>
                            <div className="value !text-black">{data?.palletId % 1000}</div>
                        </div>

                    </div>
                </div>
                <div className="grid grid-cols-2">
                    <div className="border p-2">
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">تاریخ تولید:</div>
                            <div className="value !text-black">{data?.dateOfManufacture}</div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="key !text-sm !text-gray-800">تاریخ انقضا:</div>
                            <div className="value !text-black">{data?.expireDate}</div>
                        </div>


                    </div>
                    <div className="border p-2">
                        <div className="flex items-center gap-2  mb-1">
                            <div className="key !text-sm !text-gray-800">کنترل کیفی:</div>
                            <div className="value !text-black">{data?.qualityControlSupervisor}</div>
                        </div>
                        <div className="flex items-center gap-2  ">
                            <div className="key !text-sm !text-gray-800">سرپرست تولید:</div>
                            <div className="value !text-black">{data?.seriCreateBy}</div>
                        </div>
                    </div>
                </div>

                <div className="border p-1">
                    <div className="flex items-center justify-between">
                        <div><QRCode value={`${data?.palletId}`} type='svg' color='black'/></div>
                        <div className='flex justify-between h-full flex-col flex-1'>
                            <h2 className='text-center text-xl font-bold'>{data?.palletId}</h2>
                            <div className='flex flex-col gap-1 items-center justify-center  mt-6'>

                                <img className='w-24' src={logo} alt=""/>
                                <span className='text-lg '>iotfig.com</span>

                            </div>
                        </div>
                        <div><QRCode value={`${data?.palletId}`} type='svg' color='black'/></div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrintPage;